import React, { useContext, useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../context/ThemeContext';

const slides = [
  { bg:'#f5f5f5', accentBg:'#CC0000', category:'LAPTOPS', title:'Premium Laptops', subtitle:'Power meets portability. Find your perfect laptop for work or play in Harare.', btn:'Shop Laptops', link:'/shop', image:'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=900&q=85', imageStyle:{ objectPosition:'center top', objectFit:'cover' } },
  { bg:'#111111', accentBg:'#CC0000', category:'SMARTPHONES', title:'Latest Smartphones', subtitle:'The newest phones from Samsung, iPhone and more. Best prices in Zimbabwe.', btn:'Shop Phones', link:'/shop', image:'https://images.unsplash.com/photo-1574755393849-623942496936?w=900&q=85', imageStyle:{ objectPosition:'center center', objectFit:'cover' } },
  { bg:'#f5f5f5', accentBg:'#111111', category:'DESKTOPS', title:'Powerful Desktops', subtitle:'High performance desktop computers for professionals and businesses.', btn:'Shop Desktops', link:'/shop', image:'/desktops.jpg', imageStyle:{ objectPosition:'center center', objectFit:'contain', background:'#f5f5f5' } },
  { bg:'#111111', accentBg:'#CC0000', category:'NETWORKING & STARLINK', title:'Routers & Starlink', subtitle:'Starlink satellite dishes, Wi-Fi routers and full networking solutions for Zimbabwe.', btn:'Shop Networking', link:'/shop', image:'/networking.jpg', imageStyle:{ objectPosition:'center center', objectFit:'contain', background:'#111111' } },
  { bg:'#f5f5f5', accentBg:'#CC0000', category:'PRINTERS', title:'Office Printers', subtitle:'Inkjet and laser printers for home, office and business use.', btn:'Shop Printers', link:'/shop', image:'https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?w=900&q=85', imageStyle:{ objectPosition:'center center', objectFit:'cover' } },
  { bg:'#111111', accentBg:'#CC0000', category:'PA SYSTEMS & AUDIO', title:'PA Systems & Speakers', subtitle:'Professional sound systems for events, churches and businesses in Harare.', btn:'Shop Audio', link:'/shop', image:'/pa-systems.jpg', imageStyle:{ objectPosition:'center center', objectFit:'contain', background:'#111111' } },
];

const HEADER_HEIGHT = 98;
const DELAY = 5000;

const Hero = () => {
  const { theme } = useContext(ThemeContext);
  const [cur, setCur] = useState(0);
  const autoRef = useRef(null);
  const total = slides.length;
  const slide = slides[cur];
  const isDark = slide.bg === '#111111';

  const goTo = (n) => {
    const next = (n + total) % total;
    setCur(next);
    clearInterval(autoRef.current);
    autoRef.current = setInterval(() => setCur(c => (c + 1) % total), DELAY);
  };

  useEffect(() => {
    autoRef.current = setInterval(() => setCur(c => (c + 1) % total), DELAY);
    return () => clearInterval(autoRef.current);
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@400;500;600;700;800&display=swap');

        .td-hero {
          width: 100%;
          height: calc(100vh - ${HEADER_HEIGHT}px);
          min-height: 480px;
          max-height: 750px;
          margin-top: 0;
          position: relative;
          overflow: hidden;
          font-family: 'Inter', sans-serif;
        }
        .td-slide {
          position: absolute; inset: 0; opacity: 0;
          transition: opacity 0.7s ease-in-out; z-index: 0;
          display: grid; grid-template-columns: 1fr 1fr;
        }
        .td-slide.active { opacity: 1; z-index: 1; }
        .td-left {
          display: flex; flex-direction: column; justify-content: center;
          padding: 48px 56px 48px 72px; gap: 14px;
          position: relative; z-index: 2;
        }
        .td-right { position: relative; overflow: hidden; }
        .td-right img { width: 100%; height: 100%; display: block; }
        .td-slash { position: absolute; top: 0; bottom: 0; left: -40px; width: 80px; z-index: 3; transform: skewX(-4deg); }
        .td-category { font-size: 11px; font-weight: 700; letter-spacing: 0.2em; text-transform: uppercase; padding: 4px 12px; border-radius: 100px; width: fit-content; }
        .td-title { font-family: 'Bebas Neue', sans-serif; font-size: clamp(36px, 5vw, 80px); line-height: 0.95; letter-spacing: -0.01em; margin: 0; }
        .td-subtitle { font-size: clamp(12px, 1.2vw, 16px); line-height: 1.6; margin: 0; max-width: 380px; }
        .td-buttons { display: flex; gap: 10px; flex-wrap: wrap; margin-top: 4px; }
        .td-btn-primary { display: inline-block; padding: 12px 26px; font-weight: 700; font-size: 13px; text-decoration: none; border-radius: 3px; letter-spacing: 0.02em; transition: opacity 0.2s; }
        .td-btn-primary:hover { opacity: 0.85; }
        .td-btn-secondary { display: inline-block; padding: 12px 26px; font-weight: 700; font-size: 13px; text-decoration: none; border-radius: 3px; border: 2px solid; letter-spacing: 0.02em; transition: all 0.2s; background: transparent; }
        .td-controls { position: absolute; bottom: 24px; left: 0; right: 50%; z-index: 10; display: flex; align-items: center; padding-left: 72px; gap: 16px; }
        .td-arrow { width: 36px; height: 36px; border-radius: 50%; font-size: 20px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.2s; border: 1.5px solid; background: transparent; }
        .td-arrow:hover { background: #CC0000 !important; border-color: #CC0000 !important; color: #fff !important; }
        .td-dots { display: flex; gap: 6px; align-items: center; }
        .td-dot { cursor: pointer; transition: all 0.3s ease; border-radius: 2px; height: 3px; background: rgba(150,150,150,0.4); }
        .td-dot.active { background: #CC0000; }
        .td-progress { position: absolute; bottom: 0; left: 0; height: 4px; background: #CC0000; z-index: 10; animation: tdProg 5s linear infinite; }
        @keyframes tdProg { from{width:0%} to{width:100%} }
        .td-counter { position: absolute; top: 16px; right: 20px; z-index: 10; background: rgba(0,0,0,0.5); color: #fff; font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 20px; letter-spacing: 0.1em; }
        .td-counter b { color: #CC0000; }
        .td-accent-bar { position: absolute; left: 0; top: 0; bottom: 0; width: 5px; background: #CC0000; z-index: 3; }

        /* ── TABLET ── */
        @media (max-width: 768px) {
          .td-hero { height: auto; min-height: unset; max-height: unset; margin-top: 0; }
          .td-slide { grid-template-columns: 1fr; grid-template-rows: 220px auto; }
          .td-right { order: 1; height: 220px; }
          .td-left { order: 2; padding: 28px 20px 70px 28px; gap: 12px; }
          .td-controls { right: 0; left: 0; padding-left: 28px; bottom: 16px; }
          .td-title { font-size: clamp(28px, 8vw, 48px); }
          .td-subtitle { font-size: 13px; max-width: 100%; }
        }

        /* ── MOBILE ── */
        @media (max-width: 480px) {
          .td-slide { grid-template-rows: 180px auto; }
          .td-right { height: 180px; }
          .td-left { padding: 20px 16px 64px 20px; gap: 10px; }
          .td-title { font-size: clamp(24px, 9vw, 40px); }
          .td-btn-primary, .td-btn-secondary { padding: 10px 18px; font-size: 12px; }
          .td-controls { padding-left: 16px; gap: 12px; bottom: 12px; }
          .td-arrow { width: 30px; height: 30px; font-size: 16px; }
        }
      `}</style>

      <section className="td-hero" style={{ background: slide.bg }}>
        {slides.map((s, i) => (
          <div key={i} className={`td-slide ${i === cur ? 'active' : ''}`} style={{ background: s.bg }}>
            <div className="td-left" style={{ position: 'relative' }}>
              <div className="td-accent-bar" />
              <div className="td-category" style={{ background: s.accentBg === '#CC0000' ? 'rgba(204,0,0,0.1)' : 'rgba(0,0,0,0.08)', color: s.accentBg, border: `1px solid ${s.accentBg === '#CC0000' ? 'rgba(204,0,0,0.3)' : 'rgba(0,0,0,0.15)'}` }}>
                {s.category}
              </div>
              <h1 className="td-title" style={{ color: s.bg === '#111111' ? '#ffffff' : '#111111' }}>{s.title}</h1>
              <p className="td-subtitle" style={{ color: s.bg === '#111111' ? 'rgba(255,255,255,0.75)' : '#444444' }}>{s.subtitle}</p>
              <div className="td-buttons">
                <Link to={s.link} className="td-btn-primary" style={{ background: s.accentBg, color: '#ffffff' }}>{s.btn}</Link>
                <Link to="/contact" className="td-btn-secondary" style={{ color: s.bg === '#111111' ? '#ffffff' : '#111111', borderColor: s.bg === '#111111' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.25)' }}>Contact Us →</Link>
              </div>
            </div>
            <div className="td-right" style={{ background: s.bg }}>
              <div className="td-slash" style={{ background: s.bg }} />
              <img src={s.image} alt={s.category} style={s.imageStyle} />
            </div>
          </div>
        ))}

        <div className="td-counter"><b>{String(cur + 1).padStart(2, '0')}</b> / {String(total).padStart(2, '0')}</div>

        <div className="td-controls">
          <button className="td-arrow" onClick={() => goTo(cur - 1)} style={{ color: isDark ? '#fff' : '#111', borderColor: isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.2)' }}>&#8249;</button>
          <div className="td-dots">
            {slides.map((_, i) => (
              <div key={i} className={`td-dot ${i === cur ? 'active' : ''}`} onClick={() => goTo(i)} style={{ width: i === cur ? '24px' : '6px' }} />
            ))}
          </div>
          <button className="td-arrow" onClick={() => goTo(cur + 1)} style={{ color: isDark ? '#fff' : '#111', borderColor: isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.2)' }}>&#8250;</button>
        </div>

        <div className="td-progress" key={cur} />
      </section>
    </>
  );
};

export default Hero;
